export default __webpack_public_path__ + "static/media/prev-antenna-3.0396661f.png";